import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector      : 'app-content',
	templateUrl   : './content.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class ContentComponent implements OnInit {
	@Input() contentData : any;
	public isMobile : boolean;

	constructor() {
		if ( devicePixelRatio > 1.5 && document.body.clientWidth < 767 )
            this.isMobile = true;
        else
            this.isMobile = false;
	}

	ngOnInit() {}

	onResize(event) {
		this.addStyle();
	}

	ngAfterContentInit() {
		setTimeout (
			() => {
				this.addStyle();				
			}, 1000
		);
	}

	addStyle() {
		if ( document.querySelector( '.figure-type.out_of_boundary' ) && document.getElementById( 'out_of_boundary' ) ) {
			var outOfBoundary = document.querySelector( ".figure-type.out_of_boundary" ).getBoundingClientRect().left;
			document.getElementById( 'out_of_boundary' ).style.marginLeft = "-" + outOfBoundary + "px";
			document.getElementById( 'out_of_boundary' ).style.opacity = "1";
		}
	}
}